import { getAvgHourlyPay, getBasePay, getCurrencyCode, getTotalPay, formattedCurrency, isSurgePay } from '../../utils';
import { Duration as luxonDuration } from 'luxon';
import { startsAfterNow } from '../../utils';
// TODO: Remove this and put its logic + tests in usePayLabel
export var usePayIncentive = function (shift, payRates, incentivePay) {
    var shiftDuration = luxonDuration
        .fromISO(shift.duration.value)
        .as('hours');
    var basePay = getBasePay(shiftDuration, payRates);
    var totalPay = getTotalPay(shiftDuration, payRates, incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers);
    var averageHourlyPay = getAvgHourlyPay(shiftDuration, totalPay);
    var currencyCode = getCurrencyCode(payRates === null || payRates === void 0 ? void 0 : payRates.currency, incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers);
    var displayAsAdditive = !basePay.netWage || !startsAfterNow(shift);
    var payText = displayAsAdditive
        ? formattedCurrency(incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.netPayModifier)
        : formattedCurrency({
            amount: averageHourlyPay,
            code: currencyCode
        });
    var isSurge = isSurgePay(incentivePay === null || incentivePay === void 0 ? void 0 : incentivePay.payModifiers);
    return {
        displayAsAdditive: displayAsAdditive,
        payText: payText,
        isSurge: isSurge
    };
};
